import { render } from "./HelloWorld.vue?vue&type=template&id=e1d1df06&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=e1d1df06&scoped=true&lang=css"

import exportComponent from "/Users/a123/Documents/HBuilderProjects/limit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d1df06"]])

export default __exports__